export const CURRENT_PERIOD = 'current';
export const PREVIOUS_PERIOD = 'previous';
